import './ticket-delivery.scss';
